import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ProductUnlockState } from './unlock.state';

export const ProductUnlockActions = createActionGroup({
  source: 'Product Unlock',
  events: {
    Reset: emptyProps(),
    Update: props<{ product: ProductUnlockState }>()
  }
});
